// Confirmation before abandoning an in-progress mission. Previously written
// out twice, verbatim and identically, in campaign.page.tsx and
// campaign/[id].tsx — both of which offer the same Yield button.
interface Props {
  // The game being yielded, or null when the modal is closed.
  gameId: number | null;
  yielding: boolean;
  onCancel: () => void;
  onConfirm: (gameId: number) => void;
}

export default function YieldMissionModal({
  gameId,
  yielding,
  onCancel,
  onConfirm,
}: Props) {
  return (
    <div className={`modal ${gameId !== null ? 'is-active' : ''}`}>
      <div
        className="modal-background"
        style={{ backgroundColor: 'rgba(0,0,0,0.55)' }}
        onClick={onCancel}
      />
      <div
        style={{
          position: 'relative',
          backgroundColor: 'var(--panel-bg)',
          color: 'var(--text-primary)',
          border: '1px solid rgba(68,68,102,0.6)',
          borderRadius: 10,
          maxWidth: 400,
          width: '100%',
          boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
          margin: '0 16px',
        }}
      >
        <div
          style={{
            padding: '20px 24px 12px',
            borderBottom: '1px solid rgba(68,68,102,0.35)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <h2
            className="title is-5 mb-0"
            style={{ color: 'var(--text-primary)' }}
          >
            Yield Mission
          </h2>
          <button
            className="delete is-medium"
            aria-label="close"
            onClick={onCancel}
          />
        </div>
        <div style={{ padding: '20px 24px' }}>
          <p style={{ color: 'var(--text-secondary)' }}>
            Your progress will be lost. Yield this mission?
          </p>
        </div>
        <div
          style={{
            padding: '12px 24px 20px',
            borderTop: '1px solid rgba(68,68,102,0.35)',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 8,
          }}
        >
          <button className="button is-light" onClick={onCancel}>
            Cancel
          </button>
          <button
            className={`button is-danger${yielding ? ' is-loading' : ''}`}
            onClick={() => gameId !== null && onConfirm(gameId)}
            disabled={yielding}
          >
            Yield
          </button>
        </div>
      </div>
    </div>
  );
}
